// src/mixins/exportMixin.js
export default {
  data() {
    return {
      exportDialogVisible: false,
      exportFields: [],
    };
  },
  computed: {
    exportApi() { return null; },
    currentPage() { return this.page || { current: 1, pageSize: 15 }; },
    searchParams() {
      return this.searchForm || this.form || {};
    },
  },
  methods: {
    openExportDialog() {
      if (!this.exportFields?.length) {
        this.$message.warning('未配置导出字段');
        return;
      }
      if (!this.exportApi) {
        this.$message.warning('未配置导出接口');
        return;
      }
      this.exportDialogVisible = true;
    },

    getSearchParams() {
      const raw = this.searchForm || this.form || {};
      const params = { ...raw };

      // dateRange → startTime / endTime
      if (Array.isArray(params.dateRange) && params.dateRange.length === 2) {
        const [s, e] = params.dateRange;
        params.startTime = typeof s === 'number' ? s : new Date(s).getTime();
        params.endTime = typeof e === 'number' ? e : new Date(e).getTime() + 24 * 60 * 60 * 1000 - 1;
        delete params.dateRange;
      }

      // pay_time_range → startTime / endTime
      if (Array.isArray(params.pay_time_range) && params.pay_time_range.length === 2) {
        params.startTime = params.pay_time_range[0];
        params.endTime = params.pay_time_range[1];
        delete params.pay_time_range;
      }

      // 清理空值，保留 0 / false
      Object.keys(params).forEach((key) => {
        const v = params[key];
        if (v === null || v === undefined || v === '' || (Array.isArray(v) && v.length === 0)) {
          delete params[key];
        }
      });
      return params;
    },
  },
};